import { getMobilityOpenPagesUrl } from './mobility';

const isOpenPagesForVolvia = (url: string): boolean =>
    !!getMobilityOpenPagesUrl(url) && /volvia/.test(url);

const hideFromVolviaCommercialUrl = (url: string, volviaToggle: boolean): boolean =>
    !(volviaToggle && isOpenPagesForVolvia(url));

export const hideFromMobilityUrl = (url: string, volviaToggle: boolean): boolean =>
    /\/skada/.test(url) ||
    /\/vid-skada/.test(url) ||
    (/\/foretag/.test(url) && hideFromVolviaCommercialUrl(url, volviaToggle)) ||
    /\/lastbilar/.test(url);
